import * as React from "react";
// useTheme
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
// import Stack from "@mui/material/Stack";
import CircleIcon from "@mui/icons-material/Circle";
import Grid from "@mui/material/Grid";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box } from "@mui/material";
import Slide from "@mui/material/Slide";
import { _IntoTabClick } from "./SideBar";

const PopUpItemBuilding = styled(Paper)(({ theme }) => ({
  // background: "#0D0B0B 0% 0% no-repeat padding-box",
  // ...theme.typography.body2,
  // padding: theme.spacing(2),
  height: "auto",
  position: "absolute",
  zIndex: 19,
  bottom: "85px",
  // left: "40%",
  // width: " 680px",
  // border: "1px solid #FFFFFF",
  // borderRadius: 10,
  color: "#ffffff",
  opacity: 0.88,
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: "none",
  // ...theme.typography.body2,
  // padding: theme.spacing(0.2),
  textAlign: "left",
  color: "#FFFFFF",
  "& .MuiSvgIcon-root": {
    stroke: "white",
  },
}));

const ArrowItem = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  height: "auto",
  position: "absolute",
  zIndex: 1200,
  bottom: "6px",
  // width: " 680px",
  // left: "40%",
  border: "none",
  boxShadow: "none",
  color: "#ffffff",
  // textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

/***    display: flex;
    align-items: center;
    width: calc(100% - 320px);
    justify-content: center; */
const TypoStyle = {
  font: "normal normal normal 11px/12px 'Trade Gothic LT Std', sans-serif",
  letterSpacing: 0,
  paddingLeft: "5px",
  fontWeight: "inherit",
  fontSize: "11px",
  color: "#dfdfdf",
};

let infoOpen, setInfoOpen;
function __closeInfoTab() {
  setInfoOpen(false);
}

let InfoComponent = (e) => {
  [infoOpen, setInfoOpen] = React.useState(false);
  const handleDrawerClose = (prev) => {
    setInfoOpen((prev) => !prev);
    _IntoTabClick();
  };
  return (
    <>
      {/* <Stack spacing={2}> */}

      <Slide direction="up" in={infoOpen} mountOnEnter unmountOnExit>
        <PopUpItemBuilding
          sx={{
            width: `calc(100% - ${e.margin}px)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            zIndex: 1201,
          }}
        >
          <Box
            sx={{
              width: "680px",
              height: "auto",
              position: "absolute",
              background: "#0D0B0B 0% 0% no-repeat padding-box",
              padding: 2,
              border: "1px solid #FFFFFF",
              borderRadius: 4,
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={2.5}>
                  <Item>
                    <CircleIcon
                      sx={{
                        color: "#9DB3E5",
                        float: "left",
                      }}
                    ></CircleIcon>
                    <Typography variant="caption" sx={TypoStyle}>
                      Meeting Spaces
                    </Typography>
                  </Item>
                </Grid>
                <Grid item xs={3.5}>
                  <Item>
                    <CircleIcon
                      sx={{ color: "#ECD8D7", float: "left" }}
                    ></CircleIcon>
                    <Typography variant="caption" sx={TypoStyle}>
                      Spa/Pool/Fitness Centers
                    </Typography>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item>
                    <CircleIcon
                      sx={{ color: "#ADD69A", float: "left" }}
                    ></CircleIcon>
                    <Typography variant="caption" sx={TypoStyle}>
                      Restaurants
                    </Typography>
                  </Item>
                </Grid>
                <Grid item xs={3}>
                  <Item>
                    <CircleIcon
                      sx={{ color: "red", float: "left" }}
                    ></CircleIcon>
                    <Typography variant="caption" sx={TypoStyle}>
                      Tram
                    </Typography>
                  </Item>
                </Grid>
                {/* <Grid item xs={2.5}>
                  <Item>
                    <CircleIcon
                      sx={{ color: "#BDBBBC", float: "left" }}
                    ></CircleIcon>
                    <Typography variant="caption" sx={TypoStyle}>
                      Fountains
                    </Typography>
                  </Item>
                </Grid> */}
                <Grid item xs={2.5}>
                  <Item>
                    <CircleIcon
                      sx={{ color: "#8A3CB4", float: "left" }}
                    ></CircleIcon>
                    <Typography variant="caption" sx={TypoStyle}>
                      Theater/Arenas
                    </Typography>
                  </Item>
                </Grid>
                <Grid item xs={6}>
                  <Item>
                    <CircleIcon
                      sx={{ color: "#e98928", float: "left" }}
                    ></CircleIcon>
                    <Typography variant="caption" sx={TypoStyle}>
                      Hotel Check-In/Lobby/Guest Elevator
                    </Typography>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </PopUpItemBuilding>
      </Slide>

      {/* </Stack >
            <Stack sx={{ left: '40%' }}> */}
      <ArrowItem sx={{ width: `calc(100% - ${e.margin}px)` }}>
        <IconButton
          sx={{
            background: "#000000",
            width: "41px",
            height: "22px",
            padding: 0,
            borderRadius: "16px",
            transitionDuration: "300ms",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#000000",
            },
          }}
          onClick={handleDrawerClose}
        >
          {infoOpen === true ? (
            <KeyboardArrowDownIcon sx={{ height: "30px", width: "30px" }} />
          ) : (
            <KeyboardArrowUpIcon sx={{ height: "30px", width: "30px" }} />
          )}
        </IconButton>
      </ArrowItem>
      {/* </Stack > */}
    </>
  );
};

function InfoTabComponent(e) {
  // console.log(e);
  return <InfoComponent margin={e.value} />;
}
export { InfoTabComponent, __closeInfoTab };
